/* Oct26 cart drawer: suggested product "Add" buttons, switch to subscription, delivery frequency, pair offer, Max per order.
   Works with the theme's own basket: after any change it sends the same event the
   theme uses, so lines, totals, count and the gift rule all refresh together. */
(function () {
  'use strict';
  if (window.__wmCart) return;
  window.__wmCart = true;

  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  var routes = (window.theme && window.theme.routes) || {};
  var busy = false;
  /* Click listeners use the capture phase: the drawer stops clicks from bubbling out. */

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function announce(type, response) {
    var detail = { response: response };
    document.body.dispatchEvent(new CustomEvent(type, { bubbles: true, detail: detail }));
  }

  /* Suggested products */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wm-upsell-add]');
    if (!btn || busy) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-wm-upsell-add'), 10);
    if (!id) return;
    busy = true;
    btn.disabled = true;
    post((routes.cart_add_url || '/cart/add') + '.js', {
      items: [{ id: id, quantity: 1 }],
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(function (data) {
        if (data && data.sections) announce('cascade:modalcart:afteradditem', data);
      })
      .catch(function () {})
      .then(function () { busy = false; btn.disabled = false; });
  }, true);

  /* Switch a one-off line to subscription */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wm-sub-switch]');
    if (!btn || busy) return;
    e.preventDefault();
    var plan = parseInt(btn.getAttribute('data-wm-sub-switch'), 10);
    var key = btn.getAttribute('data-wm-sub-key');
    var qty = parseInt(btn.getAttribute('data-wm-sub-qty'), 10) || 1;
    if (!plan || !key) return;
    busy = true;
    btn.disabled = true;
    post((routes.cart_change_url || '/cart/change') + '.js', {
      id: key,
      quantity: qty,
      selling_plan: plan,
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(function (data) {
        if (data && data.sections) announce('cascade:modalcart:cartqtychange', data);
      })
      .catch(function () {})
      .then(function () { busy = false; btn.disabled = false; });
  }, true);

  /* Change delivery frequency, or switch a subscription line back to one-time */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-wm-freq]') || busy) return;
    var key = sel.getAttribute('data-wm-freq-key');
    var qty = parseInt(sel.getAttribute('data-wm-freq-qty'), 10) || 1;
    if (!key) return;
    busy = true;
    sel.disabled = true;
    post((routes.cart_change_url || '/cart/change') + '.js', {
      id: key,
      quantity: qty,
      selling_plan: sel.value ? parseInt(sel.value, 10) : null,
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(function (data) {
        if (data && data.sections) announce('cascade:modalcart:cartqtychange', data);
      })
      .catch(function () {})
      .then(function () { busy = false; sel.disabled = false; });
  }, true);

  /* Swap a single bottle for the matching set, keeping one-off or subscription */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wm-pair-add]');
    if (!btn || busy) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-wm-pair-add'), 10);
    var plan = parseInt(btn.getAttribute('data-wm-pair-plan'), 10);
    var key = btn.getAttribute('data-wm-pair-key');
    var qty = parseInt(btn.getAttribute('data-wm-pair-qty'), 10) || 1;
    if (!id || !key) return;
    var line = { id: id, quantity: qty };
    if (plan) line.selling_plan = plan;
    busy = true;
    btn.disabled = true;
    post((routes.cart_add_url || '/cart/add') + '.js', { items: [line] })
      .then(function (added) {
        if (!added || added.status) throw new Error('add failed');
        return post((routes.cart_change_url || '/cart/change') + '.js', {
          id: key,
          quantity: 0,
          sections: SECTIONS,
          sections_url: window.location.pathname
        });
      })
      .then(function (data) {
        if (data && data.sections) announce('cascade:modalcart:cartqtychange', data);
      })
      .catch(function () {})
      .then(function () { busy = false; btn.disabled = false; });
  }, true);

  /* Max per order: if a product ends up over its limit, bring it back down. */
  function enforce() {
    if (busy) return;
    var root = document.querySelector('[data-cart-items]');
    if (!root) return;
    var totals = {};
    var fix = null;
    root.querySelectorAll('li[data-wm-max]').forEach(function (li) {
      var max = parseInt(li.getAttribute('data-wm-max'), 10);
      var pid = li.getAttribute('data-wm-product');
      var qty = parseInt(li.getAttribute('data-wm-qty'), 10) || 0;
      if (!max || !pid) return;
      var before = totals[pid] || 0;
      totals[pid] = before + qty;
      if (!fix && totals[pid] > max) {
        fix = { key: li.getAttribute('data-cart-item-key'), quantity: Math.max(0, max - before) };
      }
    });
    if (!fix) return;
    busy = true;
    post((routes.cart_change_url || '/cart/change') + '.js', {
      id: fix.key,
      quantity: fix.quantity,
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(function (data) {
        busy = false;
        if (data && data.sections) announce('cascade:modalcart:cartqtychange', data);
      })
      .catch(function () { busy = false; });
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(enforce, 400); }
  window.addEventListener('cascade:modalcart:afteradditem', later);
  window.addEventListener('cascade:modalcart:cartqtychange', later);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later);
  else later();
})();
